import CUSTOM_TYPOGRAPHY from '../../../features/theme/typography'

const TYPOGRAPHY = {
    fontSize: 12,
    display2: {
        fontSize: '48px',
        fontWeight: 600
    },
    h1: {
        fontSize: '40px',
        fontWeight: 600,
        ...CUSTOM_TYPOGRAPHY?.h1
    },
    h2: {
        fontSize: '32px',
        fontWeight: 600,
        ...CUSTOM_TYPOGRAPHY?.h2
    },
    h3: {
        fontSize: '24px',
        fontWeight: 600,
        ...CUSTOM_TYPOGRAPHY?.h3
    },
    h4: {
        fontSize: '20px',
        fontWeight: 600,
        ...CUSTOM_TYPOGRAPHY?.h4
    },
    h5: {
        fontSize: '16px',
        fontWeight: 600,
        ...CUSTOM_TYPOGRAPHY?.h5
    },
    h6: {
        fontSize: '14px',
        fontWeight: 600,
        ...CUSTOM_TYPOGRAPHY?.h6
    },
    h7: {
        fontSize: '12px',
        ...CUSTOM_TYPOGRAPHY?.h7
    },
    body1: {
        fontSize: '16px',
        fontWeight: 400,
        ...CUSTOM_TYPOGRAPHY?.body1
    },
    body2: {
        fontSize: '14px',
        fontWeight: '400',
        ...CUSTOM_TYPOGRAPHY?.body2
    },
    label: {
        fontSize: '12px',
        fontWeight: '400',
        ...CUSTOM_TYPOGRAPHY?.label
    },
    helper: {
        fontSize: '10px',
        fontWeight: '400',
        ...CUSTOM_TYPOGRAPHY?.label
    },
    button: {
        fontSize: '14px',
        ...CUSTOM_TYPOGRAPHY?.button
    },
    ...CUSTOM_TYPOGRAPHY?.fontSize
}

export default TYPOGRAPHY